import { HAS_ERROR_CATCH } from './constants';

export const setErrorStatus = errorCatch => ({
  type: HAS_ERROR_CATCH,
  payload: errorCatch,
});
